import Link from 'next/link';

interface Breadcrumb {
  label: string;
  url: string | null;
}

interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
  removeSlug?:boolean;
}

const Breadcrumbs = ({ breadcrumbs,removeSlug = false }: BreadcrumbsProps) => {
  return (
    <ul className='breadcrumb font-family-ie'>
      {breadcrumbs.map((breadcrumb, index) => {
        const { label, url } = breadcrumb;
        const isLast = index === breadcrumbs.length - 1;
        const showLink = !!url;

        // Remove `[slug]` from URL if it exists
        const cleanedUrl = removeSlug && url ? `/services/${url}/` : url;

        return (
          <li className='text-capitalize font-family-ie' key={url} style={{ letterSpacing: "0 !important" }}>
            {showLink ? cleanedUrl ? (
              <Link prefetch={false} href={cleanedUrl}>{label}</Link>
            ) : (
              <span>{label}</span>
            ) : label}
            {!isLast && <span className="span-a">/</span>}
          </li>
        );
      })}
    </ul>
  );
};

export default Breadcrumbs;
